var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66965 8.7014C6.44762 10.2919 7.73687 11.5753 9.3309 12.346C9.44753 12.4013 9.57654 12.4252 9.70523 12.4155C9.83392 12.4058 9.95786 12.3627 10.0648 12.2905L12.4119 10.7254C12.5157 10.6562 12.6352 10.6139 12.7594 10.6025C12.8837 10.5911 13.0088 10.6109 13.1235 10.66L17.5144 12.5419C17.6636 12.6052 17.7881 12.7154 17.8693 12.8556C17.9504 12.9959 17.9838 13.1588 17.9643 13.3197C17.8255 14.4057 17.2956 15.4039 16.4739 16.1273C15.6521 16.8508 14.5948 17.2499 13.5 17.25C10.1185 17.25 6.87548 15.9067 4.48439 13.5156C2.0933 11.1245 0.75 7.88148 0.75 4.49997C0.750058 3.40513 1.14918 2.34786 1.87264 1.5261C2.5961 0.704352 3.59428 0.174475 4.68028 0.0356886C4.84117 0.0162185 5.00403 0.0495624 5.14432 0.130697C5.28461 0.211831 5.39473 0.336361 5.4581 0.485523L7.34158 4.88032C7.3903 4.994 7.41015 5.11796 7.39936 5.24116C7.38858 5.36436 7.3475 5.48299 7.27977 5.58647L5.72011 7.96957C5.64912 8.07677 5.60716 8.20056 5.59831 8.32883C5.58947 8.4571 5.61405 8.58547 5.66965 8.7014Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumberIcon);
export default __webpack_public_path__ + "static/media/phone_number_icon.a773c1ca5c6e5b7d295fd14202f88b92.svg";
export { ForwardRef as ReactComponent };